import { Paper, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

type VisitDetailsProps = {
  vesselName: string
  vesselVisitNumber?: string | null
  voyageNumber?: Array<string> | null
  operator?: string | null
  agent?: string | null
  vesselService?: string | null
}

export const VisitDetails: FC<VisitDetailsProps> = observer(props => {
  const { vesselName, vesselVisitNumber, voyageNumber, operator, agent, vesselService } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <Paper sx={{ padding: theme.customSpacing.m, height: '100%' }}>
      <Typography variant='h6' marginBottom={theme.customSpacing.m}>
        {t('visitDetails', 'Visit details')}
      </Typography>
      <Stack direction='column'>
        <Stack direction='row' spacing={theme.customSpacing.xs}>
          <Typography variant='subtitle2'>{t('vesselName', 'Vessel Name')}:</Typography>
          <Typography variant='body2'>{vesselName}</Typography>
        </Stack>
        <Stack direction='row' spacing={theme.customSpacing.xs}>
          <Typography variant='subtitle2'>{t('portCallNumber', 'Port Call Number')}:</Typography>
          <Typography variant='body2'>{vesselVisitNumber}</Typography>
        </Stack>
        <Stack direction='row' spacing={theme.customSpacing.xs}>
          <Typography variant='subtitle2'>{t('voyageNumber', 'Voyage Number')}:</Typography>
          <Typography variant='body2'>{voyageNumber}</Typography>
        </Stack>
        <Stack direction='row' spacing={theme.customSpacing.xs}>
          <Typography variant='subtitle2'>{t('operatorAgent', 'Operator/Agent')}:</Typography>
          <Typography variant='body2'>
            {operator}/{agent}
          </Typography>
        </Stack>
        <Stack direction='row' spacing={theme.customSpacing.xs}>
          <Typography variant='subtitle2'>{t('vesselService', 'Vessel Service')}:</Typography>
          <Typography variant='body2'>{vesselService}</Typography>
        </Stack>
      </Stack>
    </Paper>
  )
})
